const projectCard = {
    tech: 'Tech',
    viewImages: 'View images',
    images: 'images',
};

export default projectCard;
